import envConfig from '../config.json'

export const env = envConfig as any;